import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "limitText",
  pure: true,
})
export class LimitTextPipe implements PipeTransform {
  transform(value: string, ...args: any[]) {
    if (value && value.length > 50) {
      return value.slice(0, 50) + "...";
    } else {
      return value;
    }
  }
}
